module.exports = __webpack_public_path__ + "img/Grapes.639cd11e.svg";